$(function() {

    $('#filefiled_bt').click(function(){
        $('#filefiled_form').find('input').trigger('click')
    })

    $('#filefiled_form').find('input').on('change', function(){
        $('#filefiled_form').submit()
    })


})
